<script setup lang="ts"></script>

<template>
  <icon name="lucide:camera" />
</template>

<style scoped></style>
